import React from "react";

interface CenterStackLayoutIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CenterStackLayoutIcon: React.FC<CenterStackLayoutIconProps> = ({ size = 22, color = '#1E1F22', className, onClick }) => (
  <svg width="353" height="51" viewBox="0 0 353 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="353" height="51" rx="3" fill="white" />
    <rect x="166.5" y="8" width="20" height="20" fill="#2D6FFF" fillOpacity="0.5" />
    <g clip-path="url(#clip0_188_10722)">
      <rect x="115" y="35.5" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
      <rect x="180" y="35.5" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
    </g>
    <defs>
      <clipPath id="clip0_188_10722">
        <rect width="123" height="5" fill="white" transform="translate(115 38)" />
      </clipPath>
    </defs>
  </svg>



);

export default CenterStackLayoutIcon;
